import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import React from 'react';

const ContactCard = (props) => {
  let { firstName, lastName, title, emailAddress, officePhone, photoBase64, mobilePhone } = props.contact;

  return (
    <Card style={{ height: '17rem' }}>
      <CardContent>
        {photoBase64 &&
          <Grid container>
            <Grid item xs={6} md={4}>
              <div><img style={{ maxHeight: '12rem' }} src={`data:image/jpeg;base64,${  photoBase64}`} alt="" /></div>
            </Grid>
            <Grid item xs={6} md={8}>
              <div>
                <div style={{ fontSize: '1.25rem' }}><strong>{`${firstName  } ${  lastName}`}</strong></div>
                <div style={{ marginTop: '1rem', fontSize: '1.1rem' }}>{title}</div>
                <div style={{ marginTop: '1rem', wordWrap: 'break-word' }}><a href={`mailto:${  emailAddress}`}>{emailAddress}</a></div>
                <div style={{ marginTop: '1rem', wordWrap: 'break-word' }}>Office: <a href={`tel:${  officePhone}`}>{officePhone}</a></div>
                <div style={{ marginTop: '1rem', wordWrap: 'break-word' }}>Mobile: <a href={`tel:${  mobilePhone}`}>{mobilePhone}</a></div>
              </div>
            </Grid>
          </Grid>
        }
        {!photoBase64 &&
          <Grid container>
            <Grid item xs={12}>
              <div style={{ fontSize: '1.25rem' }}><strong>{`${firstName  } ${  lastName}`}</strong></div>
              <div style={{ marginTop: '1rem', fontSize: '1.1rem' }}>{title}</div>
              <div style={{ marginTop: '1rem', wordWrap: 'break-word' }}><a href={`mailto:${  emailAddress}`}>{emailAddress}</a></div>
              <div style={{ marginTop: '1rem', wordWrap: 'break-word' }}>Office: <a href={`tel:${  officePhone}`}>{officePhone}</a></div>
              <div style={{ marginTop: '1rem', wordWrap: 'break-word' }}>Mobile: <a href={`tel:${  mobilePhone}`}>{mobilePhone}</a></div>
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card >
  );
};

export default ContactCard;